import { createSlice } from "@reduxjs/toolkit";

export const brandSlice = createSlice({
  name: "brand",
  initialState: {
    error: "Sorry! No Data Found.",
    message: null,
    loading: false,
    brandslist: [],
    model: false,
    error_msg: null,
    rowdata: {},
    brandParams: {
      no_of_pages: 0,
      listCount: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
  },
  reducers: {
    getBrands: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    brandListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.BrandData.count / state.brandParams.page_size
      );
      return {
        ...state,
        listCount: action.payload.BrandData.count,
        brandslist: action.payload.BrandData.results,
        loading: false,
        brandParams: {
          ...state.brandParams,
          no_of_pages: noofpages,
        },
      };
    },
    brandAdd: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    brandAddSuccessful: (state, action) => {
      return {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        rowdata: {},
      };
    },
    brandEdit: (state, action) => {
      return {
        ...state,
        model: true,
        rowdata: action.payload,
      };
    },
    brandEditSuccessful: (state) => {
      return { ...state, loading: false, rowdata: {} };
    },
    brandDelete: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    InputChangeValue: (state, action) => {
      return {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    isModelVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          model: action.payload,
          rowdata: {},
        };
      } else {
        return {
          ...state,
          model: action.payload,
        };
      }
    },
    SetBrandParams: (state, action) => {
      return {
        ...state,
        brandParams: action.payload,
      };
    },
    apiError: (state, action) => {
      return { ...state, loading: false, error_msg: action.payload };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  getBrands,
  brandListSuccessful,
  brandAdd,
  brandAddSuccessful,
  brandEdit,
  brandEditSuccessful,
  brandDelete,
  InputChangeValue,
  apiError,
  isModelVisible,
  SetBrandParams
} = brandSlice.actions;

export default brandSlice.reducer;
